<template>
  <v-select
    :name="name"
    :value="optionSelected"
    :options="optionsList"
    :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
    :disabled="isDisabled"
    :clearable="clearable"
    :placeholder="computedPlaceholder"
    :selectable="opt => !opt.disabled"
    @input="onInput"
  >
    <template #spinner>
      <b-spinner
        small
        v-if="periodState.loading"
        variant="primary"
      />
    </template>
    <template slot="no-options">
      No hay opciones para el criterio de búsqueda
    </template>
  </v-select>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'VSelectPeriod',
  computed: {
    ...mapGetters('List', [
      'periodState'
    ]),
    computedPlaceholder() {
      return this.periodState.loading ? 'Cargando opciones...' : this.placeholder;
    },
    optionSelected() {
      return this.optionsList.find((option) => option.value === this.value);
    },
    optionsList() {
      return this.periodState.list.map((opt) => ({
        value: opt.value,
        label: opt.label,
        disabled: false
      }));
    },
    isDisabled() {
      return this.disabled
        || !this.optionsList.length
        || this.periodState.loading;
    },
  },
  methods: {
    ...mapActions('List', [
      'fetchPeriod'
    ]),
    onInput(event) {
      this.$emit('full-group', event);
      this.$emit('input', event?.value);
    },
  },
  created() {
    if (this.parent[`_fetch-${this.$vnode.tag}`]) return;
    this.fetchPeriod().then(() => {
      if (this.parent) this.parent[`_fetch-${this.$vnode.tag}`] = true;
    });
  },
  props: {
    parent: { type: Object, required: true },

    name: { type: String, required: true },
    danger: { type: Boolean },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Por favor, seleccione una opción' },
    value: { type: String },
  }
};
</script>
